







































import { Component, Vue, Prop } from "vue-property-decorator";
import CatatanPemberianObatPage from "@/pages/pemeriksaan_ranap/CatatanPemberianObatPage.vue";

@Component({
  components: {
    CatatanPemberianObatPage
  }
})
export default class CpoRiwayatModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() disabled: boolean;
  @Prop() register!: string;

  mounted() {}

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  close() {
    this.dialog = false;
  }
}
